export default {
    state: {
        
    },
    mutations: {

    },
    actions: {
        loadWalletData({commit}, payload){
            const url = payload.url || '/wallet';
            return new Promise((resolve, reject)=>{
                window.axios.get(url).then(response=>{
                    const wallet = response.data.wallet;
                    if (wallet && wallet.balance){
                        commit('SET_USER_BALANCE', wallet.balance);
                    }
                    resolve(response)
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        transferBalance({state, commit}, payload){
            const url = '/wallet/transfer';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    commit('SET_USER_BALANCE', response.data.balance);
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        rechargeByMobileWallets({commit}, payload){
            const url = '/wallet/recharge/mobile-wallet';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        rechargeByRechargeCard({commit}, payload){
            const url = '/wallet/recharge/recharge-card';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        createPaymobCardOrder({commit}, payload){
            const url = '/wallet/paymob/order/card';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        createPaymobMobileWalletOrder({commit}, payload){
            const url = '/wallet/paymob/order/mobile-wallet';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        createPaymobKioskOrder({commit}, payload){
            const url = '/wallet/paymob/order/kiosk';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        createPaymobValuOrder({commit}, payload){
            const url = '/wallet/paymob/order/valu';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        createFawryOrder({commit}, payload){
            const url = '/wallet/fawry/order';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },

    }
}